import styled from '@emotion/styled';

import theme from 'theme';

import type {CSSProperties} from 'react';
import type {CaptionProps} from './types';

const getStyle = (props: CaptionProps): CSSProperties => ({
  position: props.absolute ? 'absolute' : undefined,
  color: props.error ? theme.colors.additional.red[80] : theme.colors.grey[60],
});

const Container = styled.div`
  padding: 4px 0;
  width: 100%;
  word-break: break-all;

  ${theme.typography.p3}
`;

export const Caption: React.FC<CaptionProps> = ({children, className, ...style}) => {
  if (!children) {
    return null;
  }

  return (
    <Container className={className} style={getStyle(style)}>
      {children}
    </Container>
  );
};
